export const currency = {
  methods: {
    currency(price) {
      return price != null
        ? price
            .toString()
            .replaceAll(",", "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        : "";
    },
  },
};
